export default class Faq {
  static init() {
    const faqSections = document.querySelectorAll('.faq');

    faqSections.forEach((faqElement) => {
      const triggers = faqElement.querySelectorAll('.faq__accordion-trigger');

      if (!triggers.length) return;

      // 1. INITIALIZATION ON LOAD
      // Sync the CSS class with the HTML aria-expanded state 
      // so items set to 'isOpen: true' in Nunjucks are actually open.
      triggers.forEach((trigger) => {
        if (trigger.getAttribute('aria-expanded') === 'true') {
          trigger.closest('.faq__accordion').classList.add('is-open');
        }
      });

      // 2. CLICK EVENTS
      triggers.forEach((trigger) => {
        trigger.addEventListener('click', (e) => {
          const clickedTrigger = e.currentTarget;
          const isExpanded = clickedTrigger.getAttribute('aria-expanded') === 'true';
          const currentAccordion = clickedTrigger.closest('.faq__accordion');

          // Close all accordions inside this specific FAQ
          triggers.forEach((t) => {
            t.setAttribute('aria-expanded', 'false');
            t.closest('.faq__accordion').classList.remove('is-open');
          });

          // Open the clicked one if it was previously closed
          if (!isExpanded) {
            clickedTrigger.setAttribute('aria-expanded', 'true');
            currentAccordion.classList.add('is-open');
          }
        });
      });
    });
  }
}